export const repeetInstallment = [
	{ id_tipo_repeticao: 30, description: "1 vez por mês" },
	{ id_tipo_repeticao: 5, description: "De 5 em 5 dias" },
	{ id_tipo_repeticao: 10, description: "De 10 em 10 dias" },
	{ id_tipo_repeticao: 15, description: "De 15 em 15 dias" },
	{ id_tipo_repeticao: 20, description: "De 20 em 20 dias" },
	{ id_tipo_repeticao: 25, description: "De 25 em 25 dias" },
];

export const daysOfMonth = [
	{ cobrar_dia: 1, description: "1º dia do mês" },
	{ cobrar_dia: 2, description: "2º dia do mês" },
	{ cobrar_dia: 3, description: "3º dia do mês" },
	{ cobrar_dia: 4, description: "4º dia do mês" },
	{ cobrar_dia: 5, description: "5º dia do mês" },
	{ cobrar_dia: 6, description: "6º dia do mês" },
	{ cobrar_dia: 7, description: "7º dia do mês" },
	{ cobrar_dia: 8, description: "8º dia do mês" },
	{ cobrar_dia: 9, description: "9º dia do mês" },
	{ cobrar_dia: 10, description: "10º dia do mês" },
	{ cobrar_dia: 11, description: "11º dia do mês" },
	{ cobrar_dia: 12, description: "12º dia do mês" },
	{ cobrar_dia: 13, description: "13º dia do mês" },
	{ cobrar_dia: 14, description: "14º dia do mês" },
	{ cobrar_dia: 15, description: "15º dia do mês" },
	{ cobrar_dia: 16, description: "16º dia do mês" },
	{ cobrar_dia: 17, description: "17º dia do mês" },
	{ cobrar_dia: 18, description: "18º dia do mês" },
	{ cobrar_dia: 19, description: "19º dia do mês" },
	{ cobrar_dia: 20, description: "20º dia do mês" },
	{ cobrar_dia: 21, description: "21º dia do mês" },
	{ cobrar_dia: 22, description: "22º dia do mês" },
	{ cobrar_dia: 23, description: "23º dia do mês" },
	{ cobrar_dia: 24, description: "24º dia do mês" },
	{ cobrar_dia: 25, description: "25º dia do mês" },
	{ cobrar_dia: 26, description: "26º dia do mês" },
	{ cobrar_dia: 27, description: "27º dia do mês" },
	{ cobrar_dia: 28, description: "28º dia do mês" },
	{ cobrar_dia: 29, description: "29º dia do mês" },
	{ cobrar_dia: 30, description: "30º dia do mês" },
];
